module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('i', [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("Blue Eyes")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/sta.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chtitlea"
  }, [_c('b', [_vm._v("Saturday, February 15, 1997")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin couldn’t shake an ominous feeling that had been nagging him for two days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced at the liquor cabinet. It was too early to have a drink, even by his liberal definition of when cocktail hour began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He distracted himself from that thought by picking up the "), _c('i', [_vm._v("New York Times")]), _vm._v(". And there it was again. The same blurriness he’d experienced two days earlier at work. He was doing some research for his latest grant proposal when he noticed he was unable to read an article he’d pulled off the reference shelf. The words were blurry. Soft. Out of focus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hadn’t been too concerned about it at the time. He thought he was just tired after a long day at the office, and anyway, it was a problem easily solved. He made the short trip to the Xerox machine and enlarged the print.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("But this was Saturday morning in his own home. And he’d had a good night’s sleep. His eyes were not in the least strained from a long day at work. Kevin wondered if he needed glasses. He started to blink rapidly, but his efforts produced little, if any, improvement in his vision. He put the newspaper on his coffee table and headed for the bathroom. He washed and dried his face, paying particular attention to his eyes. As he returned to his living room, he glanced out the window. It seemed foggy outside. At the same moment, he heard the weather report on the television—bitterly cold with abundant sunshine.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin couldn’t dwell on it for long, however. He was going to visit his parents on Long Island. Walking across town to Penn Station was uneventful. Kevin had done it so many times; the ten blocks from his apartment on Lexington and 37th posed no problem, even though his vision was still blurry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t need to read the information board—his train always departed from track eighteen. He headed toward it. Once on the train, he sat down in his usual seat next to the window and made himself comfortable. It was a forty-minute trip out to Mineola.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hadn’t brought the newspaper with him. There was no point in reminding himself about the eyesight issue more than necessary. Anyway, he was still convinced it was no big deal. It was, he thought once again, as simple as needing glasses. After all, he was thirty-six, and many of his friends had purchased their first pair a decade earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mother was sitting in her car when the train pulled into the station. Kevin could always count on her waiting in the parking lot—even on those evenings when he’d fallen asleep on the train and missed his stop.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Ruth Liesenberg Coughlin was a nurturing and devoted mother. She was a private duty nurse by training which suited her personality well. A kind and loving woman, not only to her family but also to her friends, she was adored by everyone. Kevin never failed to be in awe ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("of, or grateful for, her loyalty. On the other hand, Kevin felt that his father, Walter J. Coughlin, an accountant by profession, was somewhat emotionally distant. Nevertheless, Kevin appreciated the fact that he’d been a good provider for his family and a faithful husband to Ruth.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('i', [_vm._v("Kevin with his parents, Ruth and Walter Coughlin")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Kevin was the youngest of three children. His sister, Kathy, and brother, John, were ten and eight years older. The gap made him feel ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("like an only child for much of his youth, especially once Kathy and John left for college.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c61d6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13_Chapter01.vue
// module id = 96
// module chunks = 0